import { Col, Flex, Row } from 'antd';
import { Footer as FooterAnt } from 'antd/es/layout/layout';
import AddressIcon from 'assets/svg/address.svg';
import MobilePhoneIcon from 'assets/svg/mobile-phone.svg';
import PhoneIcon from 'assets/svg/phone.svg';
import clsx from 'clsx';
import * as dayjs from 'dayjs';
import PartWrapper from 'mixins/ui/part-wrapper';
import React, { FC, useEffect, useState } from 'react';
import './footer.scss';
import { checkAuthorization } from '/react4xp/mixins/check-authorization/check-authorization';
import ContactCenter from '/react4xp/parts/contact-center/contact-center';
import FooterMenuLink from '/react4xp/parts/footer-menu-link/footer-menu-link';
import ContactsModal from '/react4xp/parts/footer/components/contacts-modal/contacts-modal';
import Link from '/react4xp/parts/link/link';
import { getCachedTranslations, getTranslations } from '/react4xp/parts/main/actions';
import { EmailSource } from '/react4xp/parts/main/actions.types';
import TextWithIcon from '/react4xp/parts/text-with-icon/text-with-icon';
import VirtualAssistant from '/react4xp/parts/virtual-assistant/virtual-assistant';
const Footer: FC = (props: any) => {
    const [translations, setTranslations] = useState(() => {
        return getCachedTranslations(props.language, 'i18n/phrases,i18n/virtual-assistant/phrases');
    });
    const [isOpenContactsModal, setIsOpenContactsModal] = useState(false);

    const { translations: commonTranslations, language, token } = props;

    useEffect(() => {
        getTranslations(props.language, 'i18n/phrases,i18n/virtual-assistant/phrases').then(
            (value) => {
                setTranslations(value.data);
            }
        );
    }, []);

    const openContactsModal = () => {
        if (!token) {
            return checkAuthorization(
                { response: { status: 401 } },
                language,
                'contact-modal',
                commonTranslations
            );
        } else {
            setIsOpenContactsModal(true);
        }
    };

    const closeContactsModal = () => {
        setIsOpenContactsModal(false);
    };

    const handleOkContactsModal = () => {
        setIsOpenContactsModal(false);
    };

    const getUrl = (y) => {
        if (y.isExternal) {
            return y.externalUrl;
        }

        return `/${props.lang}${y.url}`;
    };

    const openVirtualAssistant = () => {
        window.dispatchEvent(new Event('openAssistant'));
    };

    return (
        <PartWrapper
            {...props}
            translations={translations}
        >
            <FooterAnt>
                {props.descriptor !== 'isnareactcms:auth-page' && (
                    <>
                        <div className="container">
                            <Row gutter={[0, { xs: 16, lg: 0 }]}>
                                <Col
                                    xs={24}
                                    lg={6}
                                    style={{
                                        paddingLeft: 10,
                                    }}
                                >
                                    <div className="hide-on-mobile">
                                        <p>{props.config.contact_center_title}</p>
                                    </div>
                                    <Flex
                                        style={{
                                            color: '#164B84',
                                        }}
                                        gap={10}
                                    >
                                        <ContactCenter
                                            config={{
                                                phone: props.config.short_phone,
                                            }}
                                            icon={<MobilePhoneIcon />}
                                            style={{
                                                fontSize: 16,
                                            }}
                                        />
                                        <ContactCenter
                                            config={{
                                                phone: props.config.long_phone,
                                            }}
                                            icon={<PhoneIcon />}
                                            style={{
                                                fontSize: 16,
                                            }}
                                        />
                                    </Flex>
                                </Col>

                                <Col
                                    xs={24}
                                    lg={18}
                                >
                                    <Row gutter={[16, 0]}>
                                        {props.config.menu_list?.map((x, i) => (
                                            <Col
                                                xs={12}
                                                sm={8}
                                                md={6}
                                                lg={{ flex: 'auto' }}
                                                key={i}
                                            >
                                                <FooterMenuLink
                                                    {...x}
                                                    language={props.lang}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <hr />
                        <div className="container">
                            <div className="list-footer">
                                {props.config.link_block_list &&
                                    props.config.link_block_list.map((x) => (
                                        <div className="footer-links-layout">
                                            <div className="footer-links-layout__title">
                                                {x.name}
                                            </div>
                                            <div className="d-column">
                                                {x.link_block_item_list.map((y) => {
                                                    switch (y.url) {
                                                        case '@modal':
                                                            return (
                                                                <Link
                                                                    name={y.name}
                                                                    modal={openContactsModal}
                                                                />
                                                            );
                                                        case '@openVirtualAssistant':
                                                            return (
                                                                <Link
                                                                    name={y.name}
                                                                    isButton
                                                                    onClick={() => {
                                                                        openVirtualAssistant();
                                                                    }}
                                                                />
                                                            );
                                                        case 'https://t.me/online_chat_help_bot':
                                                            return (
                                                                <Link
                                                                    name={y.name}
                                                                    url={y.url}
                                                                />
                                                            );
                                                        default:
                                                            return (
                                                                <Link
                                                                    name={y.name}
                                                                    url={getUrl(y)}
                                                                    className={clsx({
                                                                        underline:
                                                                            y.url ===
                                                                            '/pages/info-services',
                                                                    })}
                                                                />
                                                            );
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <hr />
                    </>
                )}
                <div className="container">
                    <div className="two-rows__top mb-3">
                        <TextWithIcon
                            text={props.config.address}
                            img={<AddressIcon />}
                        />
                        <TextWithIcon
                            text={props.config.phone}
                            img={<PhoneIcon />}
                        />
                    </div>
                    <div className="gray">
                        © {dayjs().year()} {props.config.portal_name}
                    </div>
                </div>

                {translations && (
                    <VirtualAssistant
                        {...props}
                        translations={translations}
                    />
                )}

                <ContactsModal
                    {...props}
                    source={EmailSource.Feedback}
                    translations={translations}
                    isModalOpen={isOpenContactsModal}
                    handleCancel={closeContactsModal}
                    handleOk={handleOkContactsModal}
                />
            </FooterAnt>
        </PartWrapper>
    );
};

export default (props) => <Footer {...props} />;
